(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4540],{

/***/ 2989:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/filter",
      function () {
        return __webpack_require__(9185);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SearchPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _components_SectionView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(570);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4850);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7239);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9741);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var __N_SSG = true;
function SearchPage(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), isReady = ref.isReady, query = ref.query, push = ref.push, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), endpoint = ref1[0], setEndpont = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(), items = ref2[0], setItems = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (isReady && (!query.type || !query.location)) {
            push("/");
        }
    }, [
        isReady
    ]);
    var ref3 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useFetchNextSWR */ .Nr)(query.type == "hotel" ? "hotel-list" : query.type == "dining" ? "dining-list" : "", {
        location: query.location
    }), 3), itemsTemp = ref3[0], isLoading = ref3[1], isError = ref3[2];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (query.type == "hotel") {
            setItems(itemsTemp);
            return;
        } else if (query.type == "dining") {
            var loc;
            if (query.location == "tangerang") {
                loc = "gading serpong";
            } else if (query.location == "bali") {
                loc = "sunset road";
            } else {
                loc = query.location;
            }
            (0,_utils_api__WEBPACK_IMPORTED_MODULE_8__/* .getWPDining */ .oW)({
                location: loc,
                _orderby: "name",
                _order: "asc"
            }).then(function(e) {
                setItems(e.data);
            });
        }
    }, [
        isReady,
        itemsTemp
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "Filter | Parador Hotels & Resorts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .safeMarginX */ .Mp,
                my: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .safeMarginX */ .Mp,
                flexDirection: "column",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                    mb: 3,
                    as: "h1",
                    fontSize: "3xl",
                    textTransform: "none",
                    fontWeight: 400,
                    color: header.color_primary,
                    textAlign: "center",
                    maxW: {
                        base: "90%",
                        md: "70%"
                    },
                    letterSpacing: "widest",
                    children: locale == "id" ? "".concat(items ? items.length : 0, " ").concat(query.type, " ditemukan di ").concat(query.location) : "".concat(items ? items.length : 0, " ").concat(query.type, "s found in ").concat(query.location)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_11__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                    orientation: "horizontal",
                    borderColor: "blackAlpha.400"
                })
            }),
            !isLoading ? query.type == "hotel" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                type: "hotels",
                title: "",
                color: header.color_primary,
                items: items ? items.map(function(param) {
                    var _ID = param._ID, name = param.name, thumbnail = param.thumbnail, hotel_location = param.hotel_location, phone = param.phone, start_from = param.start_from, email = param.email, slug = param.slug;
                    return {
                        thumb: thumbnail,
                        _ID: _ID,
                        title: name,
                        location: hotel_location,
                        phone: phone,
                        start_from: start_from,
                        email: email,
                        slug: slug
                    };
                }) : []
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "",
                color: header.color_primary,
                targetItems: items ? items.map(function(param) {
                    var _ID = param._ID;
                    return "/dining/".concat(_ID);
                }) : [],
                items: items ? items.map(function(param) {
                    var _ID = param._ID, name = param.name, thumb = param.thumb, hotel_location = param.hotel_location, phone = param.phone, start_from = param.start_from, email = param.email, hotel_name = param.hotel_name, slug = param.slug;
                    return {
                        thumb: thumb !== null && thumb !== void 0 ? thumb : "",
                        _ID: _ID,
                        title: name,
                        location: hotel_location,
                        phone: phone,
                        desc: hotel_name ? (0,_utils_functions__WEBPACK_IMPORTED_MODULE_9__/* .capEachWord */ .x8)(hotel_name) : "",
                        start_from: start_from,
                        email: email,
                        slug: slug
                    };
                }) : []
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                h: "50vh",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Spinner */ .$jN, {
                    size: "xl"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: 10
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,3981,570,9774,2888,179], function() { return __webpack_exec__(2989); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);